<template>
  <div class='sub-page'>
    <div class='sub-tab-wrap'>
      <DxTabPanel
          id="tabpanel"
          :selected-index.sync="selectedIndex"
          :data-source='tabs'
          :focusStateEnabled='true'
          @titleClick='onSelectedVendor'
        >
        <template #title="{ data: tab }">
        <div class='sub-title-wrap-tab'>
          <ul>
            <li class='float-left sub-title'>{{tab.거래처명}}</li>
          </ul>
          </div>
        </template>
      </DxTabPanel>
    </div>

    <div class='sub-content'> <!-- 여기까지 page header 이하 수정해서 사용-->
      <div class='grid-wrap'>
        <dx-data-grid ref='refInventoryGrid'
          :data-source='inventoryReceiptInfo'
          :show-borders = 'true' :showRowLines = 'false' :showColumnLines='true'
          :hover-state-enabled = "true" :allowColumnResizing = 'true'
          column-resizing-mode = 'widget' :allow-column-reordering = "true"
          :height='gridHeight' :row-alternation-enabled="true"
          :focused-row-enabled="true"
          :auto-navigate-to-focused-row="false"
          key-expr="seqId"
          @toolbar-preparing='onToolbarPreparing'
          @cell-prepared='onCellPreparedOutput'
          @row-updated='onRowUpdated'
          @row-removed="onRowRemoved" @row-removing="onRowRemoving"
        >
          <DxSearchPanel
            :visible="true"
            placeholder="검색..."
          />
          <DxExport
            :enabled="true"
            :file-name="exportTitle"
          />
          <DxEditing
            :allow-deleting="isEditable"
            :allow-updating="isEditable"
            :allow-adding="false"
            :use-icons="true"
            mode='row'
          />
          <DxFilterRow
            :visible="true"
            apply-filter="auto"
          />
          <DxColumnFixing :enabled="true"/>
          <DxColumn
            :allowEditing='false'
            :fixed="false"
            caption="처리일"
            data-field="발생일"
            dataType='date'
            format='yyyy-MM-dd'>
          </DxColumn>
          <DxColumn
            :allowEditing='true'
            :fixed="false"
            caption="처리일시"
            data-field="발생일자"
            dataType='datetime'
            format='yyyy-MM-dd HH:mm:ss'>
          </DxColumn>
          <DxColumn
            :allowEditing='false'
            :fixed="false"
            caption="품번"
            data-field="품번"
          >
          </DxColumn>
          <DxColumn
            :allowEditing='false'
            :fixed="false"
            caption="품명"
            data-field="품명"
            :visible='true'
          >
          </DxColumn>
          <DxColumn
            :allowEditing='false'
            :fixed="false"
            caption="재질"
            data-field="재질"
            :visible='true'
          >
          </DxColumn>
          <DxColumn
            :allowEditing='false'
            caption="구분"
            data-field="입출고구분"
            :visible='true'
            sort-order='desc'
          >
            <DxLookup
              :data-source="receiptTypeLookup"
              display-expr="코드명"
              value-expr="코드"
            />
          </DxColumn>
          <DxColumn
            :allowEditing='true'
            caption="중량"
            data-field="수량"
            :visible='true'
            format='#,##0'
            dataType="number"
          >
          </DxColumn>
          <DxColumn
            :allowEditing='true'
            caption="코일수"
            data-field="코일수"
            :visible='true'
            format='#,##0'
            dataType="number"
          >
          </DxColumn>
          <DxColumn
            :allowEditing='false'
            caption="구매단가"
            data-field="가격"
            :visible='true'
            format='#,##0'
            dataType="number"
          >
          </DxColumn>
          <DxColumn
            :allowEditing='false'
            caption="구매금액"
            data-field="구매금액"
            :calculate-cell-value="calcAmount"
            :visible='true'
            format='#,##0'
            dataType="number"
          >
          </DxColumn>
          <DxColumn
            :allowEditing='false'
            :visible="false"
            caption="파레트번호"
            data-field="입고키"
            format='#,##0'
            dataType="number"
          >
          </DxColumn>
          <DxColumn
            :allowEditing='false'
            caption="LOT_NO"
            data-field="lotNo"
            :visible='true'
          >
          </DxColumn>
          <DxColumn
            width="90"
            :buttons="editSubButtons"
            type="buttons"
          />
          <DxSummary>
            <DxTotalItem
              value-format='#,##0'
              column="발생일자"
              display-format="{0} (건)"
            />
            <DxTotalItem
              value-format='#,##0'
              summary-type="sum"
              column="수량"
              display-format="{0}"
            />
            <DxTotalItem
              value-format='#,##0'
              summary-type="sum"
              column="구매금액"
              display-format="{0}"
            />
          </DxSummary>
          <dx-paging :enabled="false"/>
          <dx-scrolling mode="virtual" showScrollbar='always' :useNative='false'/>
          <dx-sorting mode="multiple"/>
        </dx-data-grid>
      </div>
      <loading :active.sync="isLoading" color='rgb(2, 110, 156)' loader='bars'></loading>
    </div> <!--sub-conten end-->

  </div>
</template>

<script>
import Loading from 'vue-loading-overlay'
import DxTabPanel from 'devextreme-vue/tab-panel'
import ConstDef from '../../share/ConstDef'
import AppLib from '../../share/AppLib'
import DxDataGrid, { DxScrolling, DxFilterRow, DxColumnFixing, DxTotalItem, DxLookup,
  DxSummary, DxColumn, DxPaging, DxSorting, DxSearchPanel, DxExport, DxEditing } from 'devextreme-vue/data-grid'

export default {
  name: 'production-receipt',
  data: function () {
    return {
      isLoading: false,
      userInfo: null,
      gridHeight: null,
      selectedIndex: 0,
      tabs: [
        {
          title: '제품출하현황'
        }
      ],
      inventoryReceiptInfo: null,
      selectedRow: null,
      thisYear: null,
      yearArray: [],
      thisMonth: null,
      monthArray: [],
      exportTitle: null,
      receiptTypeLookup: null,
      focusedRowKey: null,
      editSubButtons: ['edit', 'delete'],
      isEditable: true,
      selectedVendor: null,
      processingTypeLookup: null,
      meterialTypeLookup: null
    }
  },
  components: {
    Loading,
    DxTabPanel,
    DxDataGrid,
    DxScrolling,
    DxFilterRow,
    DxColumnFixing,
    DxTotalItem,
    DxSummary,
    DxColumn,
    DxPaging,
    DxSorting,
    DxSearchPanel,
    DxExport,
    DxLookup,
    DxEditing
  },
  created () {
    document.title = ConstDef.WEB_TAB_TITLE
    this.userInfo = this.$store.getters.getUserInfo
    if (this.userInfo === null) {
      this.$router.push('/')
      return
    }
    this.thisYear = AppLib.getThisYear()
    for (let i = this.thisYear; i >= 2021; i--) {
      this.yearArray.push({ 'year': i })
    }
    this.thisMonth = AppLib.getThisMonth()
    for (let i = 1; i <= 12; i++) {
      if (i > 0 && i < 10) {
        this.monthArray.push({ 'name': i + '월', value: '0' + i })
      } else {
        this.monthArray.push({ 'name': i + '월', value: '' + i })
      }
    }
    this.meterialTypeLookup = this.$store.getters.getBaseDataByType(ConstDef.자재유형)
    this.processingTypeLookup = this.$store.getters.getBaseDataByType(ConstDef.공정유형)
    this.receiptTypeLookup = ConstDef.PURCHASE_INOUT_CODE
    this.refreshVendorList(`${this.thisYear}-${this.thisMonth}`)
  },
  mounted () {
    this.gridHeight = (screen.height - 250) * 0.95
  },
  updated () {
  },
  beforeDestroy: function () {
    this.$store.commit('deleteInoutList')
  },
  methods: {
    calcAmount (row) {
      return row.수량 * row.가격
    },
    onCellPreparedOutput (e) {
      if (e.rowType === 'data' && e.column.dataField === '입출고구분') {
        if (e.data.입출고구분 === this.$_.findWhere(ConstDef.PRODUCTION_INOUT_CODE, { 코드명: '제품반품' }).코드) { // 재공재고
          this.$Q(e.cellElement).css('color', 'red')
        }
      }
    },
    onClickPrintReceipt (e) {

    },
    onEditorPreparing (e) {
    },
    onRowRemoved (row) {
      this.isLoading = true
      this.$_sp.runDeleteSqlProc('창고수불', [{ 발주번호: row.data.발주번호 }])
        .then((data) => {
          this.isLoading = false
          this.$snotify.info('삭제 되었습니다.')
        })
        .catch(error => {
          this.isLoading = false
          if (error.response.status === ConstDef.GENERRAL_ERROR) {
            this.$snotify.error(error.response.data.message)
          } else {
            this.$snotify.error(`에러코드 : ${error.response.status}`)
          }
        })
    },
    onRowRemoving (row) {
      const 재고관리기준시간 = this.$store.getters.getSysParamByKey('재고관리기준시간')
      if (AppLib.isLessThisMonth(`${재고관리기준시간}:00`, row.data.발생일자)) {
        this.$snotify.info('전월 입고는 마감되어 삭제할 수 없습니다.')
        row.cancel = true
      }
    },
    onRowUpdated (row) {
      this.isLoading = true
      row.data.updateid = this.userInfo.userName
      row.data.updatetime = AppLib.getNow()

      this.$_sp.runUpdateSqlProc('창고수불', ['발주번호'], null, [{ 발주번호: row.data.발주번호, 수량: row.data.수량, 발생일자: row.data.발생일자, 코일수: row.data.코일수 }])
        .then((data) => {
          this.isLoading = false
          this.$snotify.info('저장 되었습니다.')
        })
        .catch(error => {
          this.isLoading = false
          if (error.response.status === ConstDef.GENERRAL_ERROR) {
            this.$snotify.error(error.response.data.message)
          } else {
            this.$snotify.error(`에러코드 : ${error.response.status}`)
          }
        })
    },
    onRowUpdating (row) {
      console.log(row)
      if (row.oldData.입출고구분 === this.$_.findWhere(ConstDef.PRODUCTION_INOUT_CODE, { 코드명: '제품출하' }).코드) {
        if (row.newData.출하차량 !== undefined && row.newData.출하차량.length === 0) {
          this.$snotify.error('납품챠량 번호를 입력하여 주세요')
          row.cancel = true
        }
      }
    },
    onSelectionChanged (e) {
      if (e != null && e.row === undefined) {
        return
      }
      if (e !== null) {
        this.selectedRow = e.row.data
      }
    },
    onToolbarPreparing (e) {
      e.toolbarOptions.items.unshift(
        {
          location: 'before',
          template: function () {
            return `<div class="toolbar-label" style='margin-left:4px;color:rgb(4, 103, 189);'><b>연도 :  </b></div>`
          }
        },
        {
          location: 'before',
          widget: 'dxSelectBox',
          options: {
            width: 80,
            items: this.yearArray,
            valueExpr: 'year',
            displayExpr: 'year',
            value: this.thisYear,
            onValueChanged: (args) => {
              this.$store.commit('deleteInoutList')
              this.thisYear = args.value
              this.refreshVendorList(`${this.thisYear}-${this.thisMonth}`)
              this.refreshInventoryList()
            }
          }
        },
        {
          location: 'before',
          template: function () {
            return `<div class="toolbar-label" style='margin-left:4px;color:rgb(4, 103, 189);'><b>월 :  </b></div>`
          }
        },
        {
          location: 'before',
          widget: 'dxSelectBox',
          options: {
            width: 80,
            items: this.monthArray,
            valueExpr: 'value',
            displayExpr: 'name',
            value: this.thisMonth,
            onValueChanged: (args) => {
              this.$store.commit('deleteInoutList')
              this.thisMonth = args.value
              this.refreshVendorList(`${this.thisYear}-${this.thisMonth}`)
              this.refreshInventoryList()
            }
          }
        }
      )
    },
    refreshInventoryList () {
      this.exportTitle = `${this.thisYear}-${this.thisMonth}-원자재수불`
      this.inventoryReceiptInfo = this.$store.getters.getMatarialInfoList(this.selectedVendor)
      if (this.inventoryReceiptInfo === null) {
        this.isLoading = true
        let endDate = `${this.thisYear}-${this.thisMonth}-${AppLib.getMonthLastDay(this.thisYear, this.thisMonth)}`
        endDate = AppLib.calcDateFromFormat(endDate, 1)
        let param = {
          startDate: `${this.thisYear}-${this.thisMonth}-01`,
          endDate: `${endDate}`,
          품목유형: ConstDef.구매품,
          자재유형: ConstDef.자재유형_원자재,
          거래처코드: this.selectedVendor,
          마감: 0 // 마감월기준: 1, 입고일기준 0
        }
        console.log(param)
        this.$_sp.runNoEncodeFindProc('spFindAllInventoryReceiptByDateAndGoodsType', param)
          .then((data) => {
            this.isLoading = false
            this.inventoryReceiptInfo = this.$_sp.MakeModel(data)
            console.log(this.inventoryReceiptInfo)
            this.$store.commit('savePurchaseInoutList', { data: this.inventoryReceiptInfo, option: param })
          })
          .catch(error => {
            this.isLoading = false
            if (error.response.status === ConstDef.GENERRAL_ERROR) {
              this.$snotify.error(error.response.data.message)
            } else {
              this.$snotify.error(`에러코드 : ${error.response.status}`)
            }
          })
      }
    },
    onSelectedVendor () {
      this.selectedVendor = this.tabs[this.selectedIndex].입고업체
      this.refreshInventoryList()
    },
    refreshVendorList (date) {
      const param = {
        toDate: `${date}-${AppLib.getMonthLastDay(date.split('-')[0], date.split('-')[1])} 23:59:59`,
        fromDate: `${date}-01`,
        자재유형: ConstDef.자재유형_원자재,
        입출고구분: ConstDef.자재입고
      }
      this.$_sp.runNoEncodeFindProc('spFindAllInputVendorList', param)
        .then((data) => {
          this.tabs = this.$_sp.MakeModel(data)
          this.tabs.unshift({ 거래처명: 'ALL', 입고업체: 'ALL' })
          console.log(this.tabs[0].입고업체)
          this.selectedVendor = this.tabs[0].입고업체
          this.refreshInventoryList()
        })
        .catch(error => {
          if (error.response.status === ConstDef.GENERRAL_ERROR) {
            this.$snotify.error(error.response.data.message)
          } else {
            this.$snotify.error(`에러코드 : ${error.response.status}`)
          }
        })
    }
  }
}
</script>

<style lang="scss">

</style>
